<div class="user-identity" [ngClass]="{ 'current-user': isCurrentUser }">
	<i [style.background]="user.color">{{ user.initials }}</i>
	<div class="about">
		<div class="name" [matBadge]="notifications" matBadgePosition="after" matBadgeOverlap="false" [matBadgeHidden]="notifications === 0">
			<span class="span-name">{{ user.displayName }}</span>
		</div>
		@if (user.online && isLiveTchat) {
			<div class="status">
				<mat-icon class="online">circle</mat-icon>
				En ligne
			</div>
		}
		@if (user.online !== null && !user.online && isLiveTchat) {
			<div class="status">
				<mat-icon class="offline">circle</mat-icon>
				Hors ligne {{ user.lastConnection }}
			</div>
		}
	</div>
</div>
